export default __webpack_public_path__ + "static/media/convert-solar-bg.6ff369ac.jpeg";